import { useContext } from 'react'

import { RibbonContext } from './RibbonProvider'

export const useRibbon = () => {
  return useContext(RibbonContext)
}
